import { useParams } from 'react-router-dom';
import { Card, Text, Box, BlockStack } from '@shopify/polaris';

export default function PurchaseOrderDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      {/* Page header card for development mode */}
      <Card>
        <Box padding="400">
          <BlockStack gap="200">
            <Text as="h1" variant="headingLg">Purchase Order #{id}</Text>
            <Text as="p" variant="bodyMd" tone="subdued">
              Detailed view of purchase order information
            </Text>
          </BlockStack>
        </Box>
      </Card>
      
      <Card>
        <Box padding="800">
          <BlockStack gap="400" align="center">
            <Text as="h2" variant="headingLg">
              Purchase Order Detail View
            </Text>
            <Text as="p" variant="bodyMd">
              This component will display detailed information about purchase order #{id}.
            </Text>
            <Text as="p" variant="bodyMd" tone="subdued">
              Coming in Phase 1 development...
            </Text>
          </BlockStack>
        </Box>
      </Card>
    </>
  );
}
